// Sugalarm — wake earcon (cycle 100). A short (~180 ms) two-tone blip
// played when the kiosk wakes to its wake word. Distinct from the alarm
// WAVs by design — it's an acknowledgment, not an alert.
//
// Kiosk-only in practice (the only caller gates on variant === "kiosk").
// Reuses a single lazily-created <audio> element.

const EARCON_SRC = "/sounds/wake.wav";

let el: HTMLAudioElement | null = null;

function getEl(): HTMLAudioElement | null {
  if (typeof window === "undefined") return null;
  if (el == null) {
    el = new Audio(EARCON_SRC);
    el.preload = "auto";
  }
  return el;
}

/** Play the wake earcon. Best-effort: a rejected play() (autoplay policy
 *  on a surface that never primed audio) is swallowed. */
export function playWakeEarcon(): void {
  const a = getEl();
  if (!a) return;
  try {
    a.currentTime = 0;
  } catch {
    /* ignore */
  }
  void a.play().catch(() => {
    /* autoplay blocked / element busy — non-fatal */
  });
}
